import { appConstants } from "../constants/appConstants"

const initialState = { accessToken: null }

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case appConstants.ACCESS_TOKEN:
      return { ...state, accessToken: action.data }
    case appConstants.RESET:
      return { ...initialState }
    default:
      return { ...state }
  }
}

export default authReducer
